import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { formatCurrency } from "utils";
import { RATE_FREQUENCIES } from "constants/index";
import { TAG_COLORS, TAG_SIZE } from "components/Tags/Tag";
import { Tag } from "components/Tags";

/**
 * PreferredRateTag
 *
 * @param {Object}  rate
 * @param {String}  size
 * @param {Object}  color
 * @param {String}  emptyMsgId
 */
const PreferredRateTag = ({
  rate,
  color = TAG_COLORS.purple,
  size = TAG_SIZE.small,
  emptyMsgId = "Global.NotProvided",
  ...props
}) => (
  <Tag color={color} size={size} {...props}>
    {rate?.amount ? (
      <FormattedMessage
        id="Profile.PreferredRateTag.Rate"
        values={{
          rate: formatCurrency(rate.amount, rate.currency),
          frequency: (
            <FormattedMessage id={`Global.${rate.frequency === RATE_FREQUENCIES.hourly ? `PerHour` : `PerMonth`}`} />
          ),
        }}
      />
    ) : (
      <FormattedMessage id={emptyMsgId} />
    )}
  </Tag>
);

PreferredRateTag.propTypes = {
  rate: PropTypes.object.isRequired,
  size: PropTypes.string,
  color: PropTypes.object,
  emptyMsgId: PropTypes.string,
};

export default PreferredRateTag;
